export class HospitalizedPatientDetailsNProcModel { 
    client_no:number
    last_name:string
    first_name:string
    tag_no:number
    pet_no:number
    pet_name:string	
    sex:string	
    weight:number	
    specie_name:string	
    breed_name:string	
    color_name:string	 

    constructor( 
        client_no:number,
        last_name:string,
        first_name:string,
        tag_no:number,
        pet_no:number,
        pet_name:string,	
        sex:string,	
        weight:number,	
        specie_name:string,	
        breed_name:string,	
        color_name:string,	 
    ) {
        this.client_no = client_no
        this.last_name = last_name
        this.first_name = first_name
        this.tag_no = tag_no
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.sex = sex
        this.weight = weight
        this.specie_name = specie_name
        this.breed_name = breed_name
        this.color_name = color_name 
    }
}
